module.exports = __webpack_public_path__ + "img/neighbourhood-dining.17552805.jpeg";